var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHashtagi = function SvgHashtagi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "#.i",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1596"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 1.6,
    "data-name": "#"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10h8",
    "data-name": "Line 98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8 17 4-10",
    "data-name": "Line 101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 17 4-10",
    "data-name": "Line 102"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14h8",
    "data-name": "Line 99"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHashtagi);
export default ForwardRef;